import { Component, OnInit } from '@angular/core';
// import { AuthService } from './services/vos/auth.service';
// import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'MadeLife';
  constructor(
    // private authService: AuthService, private router: Router,
  ) { }
  ngOnInit() {
    // let usuario = JSON.parse(this.authService.getUserLoggedIn());
    // if (!usuario) {
    //   this.router.navigateByUrl('/login');
    // if (!usuario) {
    //   localStorage.clear();
    //   this.router.navigateByUrl('/login');
    // }
    // else {
    //   this.router.navigateByUrl('/main/home');
    // }
    // }
    // else {
    //   this.router.navigateByUrl('/login');
    // }
  }
}
